import dayjs, { Dayjs } from 'dayjs';

/**
 * 定期便の変更締切日時を計算する
 *
 * 仕様:
 * - 最新の決済履歴（billingAttempts[0].createdAt）から決済時刻（時）を取得
 * - 決済履歴がない場合は、初回注文時刻（createdAt）を使用
 * - nextBillingDateから allowModifyDays日前の、決済時刻と同じ時刻を締切とする
 * - 分・秒・ミリ秒は0に設定（時間単位で切り捨て）
 *
 * 例:
 * - 決済が15:50の場合 → 締切は前日15:00:00
 * - 決済が14:15の場合 → 締切は前日14:00:00
 *
 * @param subscription - サブスクリプション情報
 * @returns 変更締切日時（Dayjs）
 */
export const calculateChangeDeadline = (subscription: {
  nextBillingDate: Date;
  createdAt: string;
  billingAttempts: Array<{ createdAt: string }>;
  shop: {
    allowModifyDays?: number;
    isAllowModifyDays?: boolean;
  };
}): Dayjs => {
  // 最新の決済時刻を取得（なければ初回注文時刻）
  const lastBillingTime = subscription.billingAttempts.length > 0
    ? dayjs(subscription.billingAttempts[0].createdAt)
    : dayjs(subscription.createdAt);

  // 決済時刻（時）を取得
  const billingHour = lastBillingTime.hour();

  // allowModifyDays が設定されている場合はその日数、なければデフォルトで1日前
  const daysToSubtract = subscription.shop.allowModifyDays || 1;

  // 締切日時を計算: nextBillingDate から daysToSubtract 日前の決済時刻
  const changeDeadline = dayjs(subscription.nextBillingDate)
    .subtract(daysToSubtract, 'day')
    .hour(billingHour)
    .minute(0)
    .second(0)
    .millisecond(0);

  return changeDeadline;
};
